import React from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"

const DonutChart = ({ rating }) => {
  const safeRating = !isNaN(rating) ? rating : 0

  const chartData = [
    ["Rating", safeRating],
    ["Remaining", 5 - safeRating]  // assumes 5 is max rating
  ]

  const data = {
    columns: chartData,
    type: "donut",
  }

  const donut = {
    title: "Top Doctor Rating",
    width: 30,
    label: { show: false },
  }

  const color = {
    pattern: ["#2990DF", "#F0F1F4"],
  }

  const size = {
    height: 300,
  }

  const onRendered = () => {
    const texts = document.querySelectorAll(".c3-chart-arcs-title")
    texts.forEach(t => (t.textContent = ""))
  }

  return (
    <C3Chart
      data={data}
      donut={donut}
      color={color}
      size={size}
      onrendered={onRendered}
    />
  )
}

export default DonutChart
